import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from './MainBanner.module.css';
import img1 from "../../assets/main.webp";
import img2 from "../../assets/everyone.webp";
import img3 from "../../assets/choir.webp";
import img4 from "../../assets/everyone2.webp";
import img5 from "../../assets/orchestra.webp";
import { useTranslation } from 'react-i18next';

const MainBanner: React.FC = () => {
  const { t } = useTranslation();

  const sliderSettings = {
    accessibility: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    draggable: false,
    dots: false,
    arrows: false,
    pauseOnHover: false,
    swipe:false,
  };

  return (
    <section className={styles.mainBanner}>
      <Slider {...sliderSettings} className={styles.slider}>
        <div>
          <img src={img1} alt="Slide 1" className={styles.sliderImage} />
        </div>
        <div>
          <img src={img2} alt="Slide 2" className={styles.sliderImage} />
        </div>
        <div>
          <img src={img3} alt="Slide 3" className={styles.sliderImage} />
        </div>
        <div>
          <img src={img4} alt="Slide 4" className={styles.sliderImage} />
        </div>
        <div>
          <img src={img5} alt="Slide 5" className={styles.sliderImage} />
        </div>
      </Slider>
      <div className={styles.content}>
        <h1>
          {t('mainBanner.title')} <strong className={styles.orchestraName}>{t('mainBanner.orchestraName')}</strong>
        </h1>
        <Link to="/tickets" className={styles.cta}>
          {t('mainBanner.cta')}
        </Link>
      </div>
    </section>
  );
};

export default MainBanner;
